exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu_wrapper[data-v-58fd8eaf]{width:400px;height:400px;overflow:auto;border:1px solid #eeeeee;padding:10px}\n", ""]);

// exports
